module.exports = __webpack_public_path__ + "media/images/admin/icons/check-a6151888542feae6b5840a95a69ed0b8.svg";